import { useRouter } from 'next/router';
import createPersistedState from 'use-persisted-state';

export const useGatedBySlug = () => {
  const router = useRouter();

  return createPersistedState(router.route)(true);
};
